import { IEnum, ILookup } from '@common/types';

import { capitalizeFirstCharLowerOthers } from './formatting-utils';
import {
  enumListAsRecordObject,
  lookupListAsRecordObject
} from './graph-utils';

export function businessPartnerLookup(data: any) {
  const personTypes: Record<string, string> = {
    INDIVIDUAL: 'Individual',
    COMPANY: 'Company'
  };

  const businessPartnerTypes: Record<string, string> = {};
  data?.BusinessPartnerType?.enumValues?.forEach((el: any) => {
    businessPartnerTypes[el.name] = el.name
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/^\w/, (c: any) => c.toUpperCase());
  });

  const addressTypes: Record<string, string> = {
    WORK: 'Work',
    HOME: 'Home'
  };

  const personTitles: Record<string, string> = {};
  data?.core?.getTitles?.forEach((el: any) => {
    personTitles[el.id] = el.title;
  });

  const relatedCompanies: Record<string, string> = {};
  data?.salesforce?.getRelatedCompanies?.forEach((el: any) => {
    relatedCompanies[el.id] = el.title;
  });

  const activePersons: Record<string, string> = {};
  data?.salesforce?.getActivePersons?.forEach((el: any) => {
    activePersons[el.id] = el.fullName;
  });

  const countries: Record<string, string> = {};
  data?.core?.getCountries?.forEach((el: any) => {
    countries[el.id] = el.title;
  });

  const zones: Record<string, string> = {};
  data?.core?.getZones?.forEach((el: any) => {
    zones[el.id] = el.title;
  });

  const currencies: Record<string, string> = {};
  data?.core?.getCurrencies?.forEach((el: any) => {
    currencies[el.id] = el.title;
  });

  return {
    personTypes,
    businessPartnerTypes,
    addressTypes,
    personTitles,
    relatedCompanies,
    activePersons,
    countries,
    zones,
    currencies
  };
}

export function userLookup(data: any) {
  const businessUserDetailsList: Record<string, Record<string, string>> = {};
  businessUserDetailsList[data.UserStatus.name] = enumListAsRecordObject(
    data.UserStatus.enumValues
  );
  const userTypeLookup = enumListAsRecordObject(data.UserType.enumValues);

  if (userTypeLookup['BROKER_POS']) {
    userTypeLookup['BROKER_POS'] = 'Broker POS';
  }

  businessUserDetailsList[data.UserType.name] = userTypeLookup;

  businessUserDetailsList[data.PersonAddressType.name] = enumListAsRecordObject(
    data.PersonAddressType.enumValues
  );

  businessUserDetailsList['access'] = lookupListAsRecordObject(
    data.core.getUserAccesses
  );
  businessUserDetailsList['countries'] = lookupListAsRecordObject(
    data.core.getCountries
  );
  businessUserDetailsList['zones'] = lookupListAsRecordObject(
    data.core.getZones
  );
  businessUserDetailsList['Titles'] = lookupListAsRecordObject(
    data.core.getTitles
  );
  businessUserDetailsList['Roles'] = data.core.getRoles.reduce(
    (acc: Record<string, string>, role: string) => {
      acc[role] = role;

      return acc;
    },
    {}
  );
  businessUserDetailsList['ActivePersons'] =
    data?.salesforce?.searchPersons?.items
      ?.filter(
        (person: { userId: string | null; fullName: string; id: string }) =>
          !person.userId
      )
      ?.reduce(
        (
          acc: Record<string, string>,
          person: { id: string; fullName: string }
        ) => {
          acc[person.id] = person.fullName;

          return acc;
        },
        {}
      );

  return businessUserDetailsList;
}

export function lookupToList(data: ILookup[]) {
  return (
    data?.reduce(
      (acc, el) => {
        acc[el.id] = el.title;

        return acc;
      },
      {} as Record<string, string>
    ) || {}
  );
}

export function enumToList(data: IEnum[]) {
  return (
    data?.reduce(
      (acc, el) => {
        acc[el.name] = capitalizeFirstCharLowerOthers(el.name);

        return acc;
      },
      {} as Record<string, string>
    ) || {}
  );
}
